<template>
  <div class="container">
    <div class="head">
      <div class="title">
        <div class="text">投诉超24小时未办结</div>
        <div class="right-five-txt">
            <div v-if="twentyDetail.deduction=='0'" class="no-de">未扣分</div>
            <div v-else class="branch" :class=" isExceed == 1 ? 'txtDec' : ''">-{{twentyDetail.deduction}}</div>
            <div class="timememo"  v-if="isExceed == 1 ">已达扣分上限</div>
        </div>
        
      </div>
      <div class="tag-box">
        <txtTag
          class="tag"
          :bgColor="'#fff'"
          :border="'#36B374'"
          :txtColor="'#36B374'"
        >{{twentyDetail.areaName}}</txtTag>
        <!-- <txtTag
          class="tag"
          :bgColor="'#fff'"
          :border="'#36B374'"
          :txtColor="'#36B374'"
        >{{twentyDetail.areaType=='1' ? '一' : '二'}}类地区</txtTag> -->
      </div>
      <div class="date">{{twentyDetail.quarterCN}}</div>
    </div>

    <div class="pg-pd12">
      <!-- 扣分原因 -->
      <template>
        <causeDeduction :causeContent="twentyDetail.deductionReason" causeTitle="扣分原因"></causeDeduction>
      </template>

      <!-- 扣分详情 -->
      <!-- dev-1.2.0关闭 -->
      <template>
        <causeDetail :detailList="detailList" title="扣分详情"></causeDetail>
      </template>

      <!-- 投诉件详情 -->
      <!-- dev-1.2.0关闭 -->
        <template>
          <div class="complain" @click="navToComplain">
            <span>查看投诉件详情</span>
          </div>
        </template>
    </div>
  </div>
</template>
<script>
// import Vue from 'vue';
import causeDeduction from "../../components/causeDeduction"; // 扣分原因
import causeDetail from "../../components/causeDetail"; // 扣分详情 企业详情
import txtTag from "../../components/txt-tag";
import api from "../../../../service/modules/appraiseNew";
import util from "../../../../utils/common";
import { type } from "os";
// Vue.use(Picker);
export default {
  components: {
    causeDeduction,
    txtTag,
    causeDetail
  },

  data() {
    return {
      // 投诉件详情
      detailList: [],
      twentyDetail: {},
      isExceed: this.$route.query.isExceed
    };
  },
  methods: {
    // 详情
    async getComplainById() {
      const { orderSubNo, orderNo } = this.$route.query;
      let params = {
        orderSubNo,
        orderNo,
        dealType: 'B2'
      }
      let res = await api.getComplainById(params);
      if(res.ret === 0) {
        this.twentyDetail = res.data;
        this.detailList = [{
                  name: "投诉单号",
                  value: res.data.orderNo
                },
                {
                  name: "发生地区",
                  value: res.data.subCityName
                },
                {
                  name: "处理时长",
                  value: res.data.dealDuration
                },
                {
                  name: "一次处理时长",
                  value: res.data.handleTime
                },
                {
                  name: "二次处理时长",
                  value: res.data.appealHandleTime
                }]
      }
    },

    // 查投诉详情信息跳转到投诉详细界面
    navToComplain() {
      let query =  {
          complainNumber: this.twentyDetail.orderSubNo,
          mainComplainNumber: this.twentyDetail.orderNo
        }
      // this.$router.push({
      //   name: 'assessDetails',
      //   query
      // })
      // util.setJsonLocal('item', query);
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: `yyngov://complaint?path=complain_detail_container&mainComplainNumber=${query.mainComplainNumber}&complainNumber=${query.complainNumber}`,
          isFullScreen: 0,
          setTitle: title,
          needLoading: 1,
        },
        (cb) => {
          console.log(cb, "openWindow");
        })
    },
  },

  mounted() {},

  created() {
    this.getComplainById();
  }
};
</script>
<style scoped lang="less">
@vv: 3.75vw;
.container {
  min-height: 100vh;
  background: rgba(251, 251, 251, 1);
  padding-bottom: 24px;

  .pg-pd12 {
    padding-left: 12px;
    padding-right: 12px;
  }

  .complain {
    position: relative;
    line-height: 46px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    padding: 0 16px;
    margin-top: 24px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
  }
  .complain::after {
    content: "";
    position: absolute;
    right: 16px;
    top: 16px;
    width: 12px;
    height: 12px;
    background: url('../../../../assets/image/t-right.png') no-repeat;
    background-size: 12px 12px;
  }

  .head {
    width: 100%;
    background: #fff;
    padding: 23px 12px 12px 12px;

    .title {
      line-height: 22px;
      display: flex;
      justify-content: space-between;

      .text {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        line-height: 28px;
        padding-right: 50px;
      }

      .branch {
        height: 22px;
        font-size: 22px;
        font-family: DIN-Medium, DIN;
        font-weight: 500;
        color: rgba(255, 77, 77, 1);
        line-height: 28px;
      }
      .no-de {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(54, 179, 116, 1);
        line-height: 22px;
      }
    }
    .tag-box {
      width: 120%;
      height: 28px;
      display: flex;
      align-items: center;
      margin-top: 10px;
      transform: scale(0.5);
      transform-origin: left 0;
    }
    .date {
      margin-bottom: 12px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 12px;
    }
  }
  .main {
    margin-top: 24px;

    .title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: rgba(51, 51, 51, 1);
    }

    .content {
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
      border-radius: 3px;
      margin-top: 12px;
      .pro-mr {
        margin-top: 24px;
        padding: 12px;
      }
      .tongji {
        display: flex;
        align-items: center;

        .tj-item {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          padding: 16px 0;
          text-align: center;

          .name {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
          }

          .num {
            font-size: 20px;
            font-family: DIN-Bold, DIN;
            font-weight: bold;
            color: rgba(54, 179, 116, 1);
            margin-top: 8px;
            vertical-align: top;
            display: inline-block;
            text-align: center;
            position: relative;

            span {
              font-size: 10px;
              padding-left: 4px;
              font-weight: normal;
              position: absolute;
              float: left;
              display: inline-block;
              font-weight: normal;
              bottom: 2px;
            }
          }
        }
      }
      .mt015 {
        margin-top: -15px;
      }

      .ts-list {
        width: 100%;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(155, 155, 155, 1);
        position: relative;
        vertical-align: top;
        display: inline-block;
        text-align: center;
        line-height: 41px;
        .img {
          position: absolute;
          float: left;
          display: inline-block;
          width: 10px;
          height: 10px;
          top: 50%;
          transform: translateY(-50.5%);
          img {
            width: 100%;
          }
        }
      }
    }
  }
  .right-five-txt{
    position: relative;
  }
  .txtDec{
    text-decoration: line-through;
  }
  .timememo {
    color: #ff8c19;
    font-size: 12px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    // text-align: right;
    width: 100px;
    margin-top: 6px;
    position: absolute;
    right: -30px;
  }
}
</style>
